import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "dialog-detail-resi" }
const _hoisted_2 = {
  class: "flex w-full justify-between items-center px-2 pb-5",
  style: {"border-bottom":"1px solid #CFD8DC"}
}
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("h6", { class: "font-semibold text-xl text-black" }, /*#__PURE__*/_toDisplayString('Detail Resi'))
], -1)
const _hoisted_4 = { class: "background-grey-lighten-5 px-5 py-5 mb-4 rounded-lg" }
const _hoisted_5 = { class: "flex flex-wrap md:flex-nowrap w-full justify-between" }
const _hoisted_6 = { class: "py-2 w-full lg:w-auto mr-2" }
const _hoisted_7 = { class: "font-bold text-2xl break-all" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "color-primary" }
const _hoisted_10 = { class: "flex flex-col  items-center" }
const _hoisted_11 = { class: "lg:w-auto w-full py-2 flex items-center" }
const _hoisted_12 = { class: "font-semibold lg:text-base md:text-base text-sm px-2 rounded-lg background-blue-grey-lighten-5 border-radius-blue-grey-darken-1 color-blue-grey" }
const _hoisted_13 = { class: "grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2" }
const _hoisted_14 = { class: "lg:mb-0 md:mb-0 mb-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-1 color-blue-grey" }, "Pengirim", -1)
const _hoisted_16 = { class: "font-semibold mb-1 break-all" }
const _hoisted_17 = { class: "font-semibold mb-1 break-all" }
const _hoisted_18 = { class: "lg:hidden md:hidden block" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-2 mt-2 color-blue-grey" }, "Biaya Tambahan : ", -1)
const _hoisted_20 = { class: "color-red font-semibold" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-1 color-blue-grey" }, "Penerima", -1)
const _hoisted_23 = { class: "font-semibold mb-1 break-all" }
const _hoisted_24 = { class: "font-semibold mb-1 break-all" }
const _hoisted_25 = { class: "grid-cols-2 gap-2 lg:grid md:grid hidden" }
const _hoisted_26 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-2 mt-4 color-blue-grey" }, "Biaya Tambahan : ", -1)
const _hoisted_27 = { class: "color-red font-semibold" }
const _hoisted_28 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-2 mt-4 color-blue-grey" }, "Keterangan Biaya Tambahan:", -1)
const _hoisted_30 = { class: "col-span-2" }
const _hoisted_31 = { class: "font-bold" }
const _hoisted_32 = { class: "color-blue-grey" }
const _hoisted_33 = { class: "font-bold" }
const _hoisted_34 = { class: "flex items-center p-4 w-full justify-between" }
const _hoisted_35 = /*#__PURE__*/_createVNode("p", { class: "font-normal text-lg" }, "Barang Pada Resi", -1)
const _hoisted_36 = { class: "font-normal" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Total ")
const _hoisted_38 = { class: "font-bold" }
const _hoisted_39 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_40 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_41 = { class: "flex" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Konfirmasi")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Dialog, {
      visible: $setup.dialogDetailResi,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ($setup.dialogDetailResi = $event)),
      class: "dialog-voucher",
      modal: true,
      dismissableMask: false,
      style: {"width":"60vw"}
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("i", {
            class: "pi pi-times text-black cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.hidedialogDetailResi()))
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode("div", _hoisted_41, [
          ($props.dataSource.StatusPengirimanId === 8)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "btn-primary text-black mr-3 px-10 py-1",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.processScanResi($props.dataSource.Guid)))
              }, {
                default: _withCtx(() => [
                  _hoisted_42
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            class: "btn-secondary text-black mr-3 px-10 py-1",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.hidedialogDetailResi()))
          }, {
            default: _withCtx(() => [
              _hoisted_43
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("p", _hoisted_7, _toDisplayString($props.dataSource.Resi), 1),
              _createVNode("span", _hoisted_8, [
                _createVNode("p", _hoisted_9, _toDisplayString(`${$props.dataSource.AgenAsal.Kota.Nama} - ${$props.dataSource.AgenTujuan.Kota.Nama}`), 1)
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, _toDisplayString($props.dataSource.StatusPengiriman.Status), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode("p", _hoisted_16, _toDisplayString(`${$props.dataSource.NamaPengirim} (${$props.dataSource.HpPengirim})`), 1),
              _createVNode("p", _hoisted_17, _toDisplayString($props.dataSource.AlamatPengirim), 1),
              _createVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode("p", _hoisted_20, _toDisplayString(`Rp ${$props.dataSource.SumBiayaTambahan}`), 1)
              ])
            ]),
            _createVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode("p", _hoisted_23, _toDisplayString(`${$props.dataSource.NamaPenerima} (${$props.dataSource.HpPenerima})`), 1),
              _createVNode("p", _hoisted_24, _toDisplayString($props.dataSource.AlamatPenerima), 1)
            ])
          ]),
          _createVNode("div", _hoisted_25, [
            _createVNode("div", null, [
              _hoisted_26,
              _createVNode("p", _hoisted_27, _toDisplayString(`Rp ${$props.dataSource.SumBiayaTambahan}`), 1)
            ])
          ]),
          ($props.dataSource.TransPengirimanHdBiayaTambahans.length > 1)
            ? (_openBlock(), _createBlock("div", _hoisted_28, [
                _hoisted_29,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.dataSource.TransPengirimanHdBiayaTambahans, (datas) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "grid grid-cols-3 gap-2 mt-2",
                    key: datas.Id
                  }, [
                    _createVNode("div", _hoisted_30, [
                      _createVNode("p", _hoisted_31, _toDisplayString(datas?.MsBiayaTambahan?.Nama), 1),
                      _createVNode("p", _hoisted_32, _toDisplayString(`(${datas.Keterangan})`), 1)
                    ]),
                    _createVNode("p", _hoisted_33, "Rp " + _toDisplayString(datas.Nominal), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Card, { class: "card-no-shadow card-p-0 mb-5" }, {
          content: _withCtx(() => [
            _createVNode("div", _hoisted_34, [
              _hoisted_35,
              _createVNode("p", _hoisted_36, [
                _hoisted_37,
                _createVNode("span", _hoisted_38, _toDisplayString(`${$props.dataSource.TotalColly} Koli`), 1)
              ])
            ]),
            _createVNode(_component_DataTable, {
              value: $props.dataSource.TransPengirimanDetails,
              class: "table-og body-td-x-0",
              responsiveLayout: "scroll"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, { header: "Satuan" }, {
                  body: _withCtx((slotProps) => [
                    _createVNode("p", _hoisted_39, _toDisplayString(`${slotProps.data.Berat} ${slotProps.data.KategoriBarang.Satuan.Kode}`), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { header: "Kategori Barang" }, {
                  body: _withCtx((slotProps) => [
                    _createVNode("p", _hoisted_40, _toDisplayString(slotProps.data.KategoriBarang.Nama), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}